<script setup>
import { onMounted, computed } from "vue";
import { useGlobalStore } from "@stores/global";
import { useShopifyStore } from "@stores/shopify";
import { useRoute } from "vue-router";

const route = useRoute();
const shopify = useShopifyStore();
const global = useGlobalStore();

const policy = computed(() => {
	return (
		Object.values(shopify.policies).find(
			(policy) => policy && policy.slug === route.params.slug,
		) ?? null
	);
});

onMounted(() => {
	global.setTheme(null, null, null);
});
</script>

<template>
	<section class="overflow-hidden pt-48 lg:pt-160" v-if="policy">
		<div class="container">
			<div class="relative mb-48 lg:mb-80">
				<h1 class="lg:h2 h4 font-primary" ref="titleEl">
					{{ policy.title }}
				</h1>
				<div
					class="font-primary absolute -bottom-16 -left-90 hidden text-[200px] leading-[0.7] whitespace-nowrap text-transparent uppercase opacity-10 lg:block"
					style="
						-webkit-text-stroke-width: 1px;
						-webkit-text-stroke-color: black;
					"
					aria-hidden="true"
				>
					{{ policy.title }}
				</div>
			</div>
			<div class="prose" v-html="policy.body"></div>
		</div>
	</section>
</template>
